import { RouterModule, Routes } from "@angular/router";
import { MyAccountComponent } from "./components/myAccount.component";
import { ControlPanelComponent } from "./control-panel/control-panel.component";

import { ProfileComponent } from "../profile/components/profile.component";
import { NgModule } from "@angular/core";
import { MembershipsComponent } from "./memberships/components/memberships.component";

const routes: Routes = [
    {
        path: "",
        component: MyAccountComponent,
        children: [
            { path: "dashboard", component: ControlPanelComponent },
            { path: "memberships", component: MembershipsComponent },
            { path: "details", component: ProfileComponent },

            // default
            // { path: "", redirectTo: "details", pathMatch: "full" }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ProfilePageRoutingModule { }

